// Module
var code = "<div class=\"flex row fg-edit form-group\" ng-form=\"$fg\"> <div class=\"form-edit-canvas flex-column col s10\"> <div fg-form fg-edit-canvas fg-no-render=\"true\"></div> </div> <div class=\"form-edit-palette flex-column col s2\" ng-form=\"$palette\" fg-null-form> <div fg-form fg-edit-palette fg-no-render=\"true\"></div> </div> </div> ";
// Exports
export default code;